var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealSigned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 7,
    fill: "#EBFBF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0424 10.2268L15.5401 15.6295L12.5293 12.6187L13.7667 11.3812L15.4226 13.037L18.698 9.10645L20.0424 10.2268Z",
    fill: "#22E295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13V1C0 0.447715 0.447715 0 1 0H9.19401C9.45435 0 9.70443 0.101528 9.89109 0.283005L11.6971 2.03883C11.8907 2.22711 12 2.48572 12 2.75582V13C12 13.5523 11.5523 14 11 14H1C0.447715 14 0 13.5523 0 13Z",
    fill: "#DEDCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00006 3.00586H9.00006C9.40243 3.00586 9.72863 3.31926 9.72863 3.70586C9.72863 4.09246 9.40243 4.40586 9.00006 4.40586H3.00006C2.59768 4.40586 2.27148 4.09246 2.27148 3.70586C2.27148 3.31926 2.59768 3.00586 3.00006 3.00586Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57129 7.00063C2.57129 6.77322 2.76317 6.58887 2.99986 6.58887H6.42843C6.66513 6.58887 6.857 6.77322 6.857 7.00063V7.00063C6.857 7.22804 6.66513 7.4124 6.42843 7.4124H2.99986C2.76317 7.4124 2.57129 7.22804 2.57129 7.00063V7.00063Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00006 6.30078H6.42863C6.83101 6.30078 7.1572 6.61418 7.1572 7.00078C7.1572 7.38738 6.83101 7.70078 6.42863 7.70078H3.00006C2.59768 7.70078 2.27148 7.38738 2.27148 7.00078C2.27148 6.61418 2.59768 6.30078 3.00006 6.30078Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57129 10.2946C2.57129 10.0672 2.76317 9.88281 2.99986 9.88281H7.28557C7.52227 9.88281 7.71415 10.0672 7.71415 10.2946V10.2946C7.71415 10.522 7.52227 10.7063 7.28557 10.7063H2.99986C2.76317 10.7063 2.57129 10.522 2.57129 10.2946V10.2946Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00006 9.59375H7.28577C7.68815 9.59375 8.01434 9.90715 8.01434 10.2937C8.01434 10.6803 7.68815 10.9937 7.28577 10.9937H3.00006C2.59768 10.9937 2.27148 10.6803 2.27148 10.2937C2.27148 9.90715 2.59768 9.59375 3.00006 9.59375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealSigned);
export default __webpack_public_path__ + "static/media/deal-signed.7dfa908d.svg";
export { ForwardRef as ReactComponent };